__turbopack_context__.v({
  "mainContainer": "WarehousesStatistic-module-scss-module__AptnHa__mainContainer",
  "map": "WarehousesStatistic-module-scss-module__AptnHa__map",
  "next": "WarehousesStatistic-module-scss-module__AptnHa__next",
  "prev": "WarehousesStatistic-module-scss-module__AptnHa__prev",
  "section": "WarehousesStatistic-module-scss-module__AptnHa__section",
  "seeOnMapButton": "WarehousesStatistic-module-scss-module__AptnHa__seeOnMapButton",
  "sliderButton": "WarehousesStatistic-module-scss-module__AptnHa__sliderButton",
  "subtitle": "WarehousesStatistic-module-scss-module__AptnHa__subtitle",
  "textContainer": "WarehousesStatistic-module-scss-module__AptnHa__textContainer",
  "title": "WarehousesStatistic-module-scss-module__AptnHa__title",
  "workWith": "WarehousesStatistic-module-scss-module__AptnHa__workWith",
  "workWithItem": "WarehousesStatistic-module-scss-module__AptnHa__workWithItem",
  "workWithSlider": "WarehousesStatistic-module-scss-module__AptnHa__workWithSlider",
  "workWithTitle": "WarehousesStatistic-module-scss-module__AptnHa__workWithTitle",
});
